(function () {
    "use strict";

    // required to support IE 11
    cip_StatusWidget.createDefaultScreen = function () {
        return '' +
            '<div id="content">' +
                '<div id="summaryPanel" style="display:none;"></div>' +
                '<div id="applicationStatusPanel">' +
                    '<h1>Application Status</h1>' +
                    '<div id="applicationDetailOverviewPanel" style="display:none;"></div>' +
                    '<div id="applicationDetailCommentsPanel" style="display:none;" href="#applicationDetailCommentsPanel"></div>' +
                    '<div id="applicationDetailDocumentsPanel" style="display:none;" href="#applicationDetailDocumentsPanel"></div>' +
                '</div>' +
            '</div>';
    };

    cip_StatusWidget.createApplicationSummaryTable = function (summaries) {
        var html = '<div>' +
            '<table id="summaryTable" class="tablesorter" cellspacing="1">' +
            '<thead>' +
            '<tr class="header">' +
            '<th style="width:210px;">Case Id</th>' +
            '<th>Form</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>';

        cc_Util.invokeOnElements(summaries, function () {
            html += '<tr id="summary_' + this.id + '" data-id="' + this.id + '" data-form="' + this.formId + '">' +
                '<td class="firstCell summaryId">' + this.id + '</td>' +
                '<td>' + this.formText + '</td>' +
                '</tr>';
        });

        html += '</tbody>' +
            '</table>' +
            '</div>';

        return html;
    };

    cip_StatusWidget.toApplicantFullName = function (firstName, lastName) {
        var fullName = cc_Config.notEnteredValue;

        if (firstName || lastName) {
            fullName = (firstName ? firstName : cc_Config.notEnteredValue) + ' ' + (lastName ? lastName : cc_Config.notEnteredValue);
        }

        return fullName;
    };

    cip_StatusWidget.toExecutedActorName = function (item) {
        if (item.type == "SYSTEM") {
            return 'system';
        } else if (item.firstName && item.lastName) {
            return item.firstName + " " + item.lastName;
        } else if (item.type == 'APPLICANT' && item.name) {
            return item.name;
        } else if (item.type == 'APPLICANT') {
            return 'you';
        } else {
            return 'operator';
        }
    };

    cip_StatusWidget.createOverviewPanel = function (applicationDetail) {
        var html = '' +
            cip_StatusWidget.createApplicationDetailsPanel(applicationDetail) +
            cip_StatusWidget.createApplicationActionPanel(applicationDetail);

        return html;
    };

    cip_StatusWidget.createApplicationDetailsPanel = function(applicationDetail) {
        return '' +
            '<div id="applicationDetailsPanel">' +
                '<div class="panel-body sectionHeader w-full">' +
                    '<legend>Details</legend>' +
                    '<div class="flex flex-col gap-2.5">' +
                        '<div>' +
                            '<span class="summaryLabel">Status:</span>' +
                            '<span class="summaryValue">' + applicationDetail.stageText + '</span>' +
                        '</div>' +
                        '<div>' +
                            '<span class="summaryLabel">Case ID:</span>' +
                            '<span class="summaryValue">' + applicationDetail.id + '</span>' +
                        '</div>' +
                        '<div>' +
                            '<span class="summaryLabel">Case Started:</span>' +
                            '<span class="summaryValue">' + dateFns.distanceInWordsStrict(new Date(applicationDetail.startDate), new Date()) + '</span>' +
                        '</div>' +
                        '<div>' +
                            '<span class="summaryLabel">Last Updated:</span>' +
                            '<span class="summaryValue">' + $.format.date(new Date(applicationDetail.startDate), cc_Config.dateFormat) + '</span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>';
    };

    cip_StatusWidget.createApplicationActionPanel = function(applicationDetail) {
        var editInterviewOperation = applicationDetail.editInterviewOperation != null
            ?   '<div id="editInterviewButton" class="btn btn-primary operation" target="_blank" onclick=window.open("' + cip_Common.toApplicationPageFromStatusPageUrl(applicationDetail.formId, applicationDetail.id) + '")>' +
                    applicationDetail.editInterviewOperation.description +
                '</div>'
            :   '';

        var nextStepOperations = applicationDetail.nextStepOperations && applicationDetail.nextStepOperations.length > 0
            ?   applicationDetail.nextStepOperations.map(function(nextStepOperation) {
                    var confirmationDescription = nextStepOperation.confirmation && nextStepOperation.confirmation.description ? 'custom-operation-confirmation-text="' + nextStepOperation.confirmation.description + '"' : '';
                    return '' +
                        '<input type="button" class="btn btn-primary operation nextStepOperation" value="' + nextStepOperation.description + '" custom-operation-id="' + nextStepOperation.operationId + '"' + confirmationDescription + '>';
                }).join("")
            :   '';

        var addDocumentOperation = applicationDetail.addDocumentOperation != null
            ?   '<input name="addDocumentButton" type="button" class="btn btn-primary operation" value="Add Document">'
            :   '';

        var addCommentOperation = applicationDetail.addCommentOperation != null
            ?   '<input name="addCommentButton" type="button" class="btn btn-primary operation" value="Add Comment">'
            :   '';

        return '' +
            '<div id="nextStepOperationsPanel">' +
                '<div class="panel-body sectionHeader w-full">' +
                    '<legend>Actions</legend>' +
                    '<div class="flex flex-col gap-2.5">' +
                        editInterviewOperation +
                        nextStepOperations +
                        addDocumentOperation +
                        addCommentOperation +
                    '</div>' +
                '</div>' +
            '</div>';
    }

    cip_StatusWidget.createCommentsPanel = function (comments) {
        return '' +
            '<div id="commentsPanel">' +
                '<div class="panel-body sectionHeader">' +
                    '<legend>Comments</legend>' +
                    cip_StatusWidget.createCommentsTable(comments) +
                '</div>' +
            '</div>';

    };

    cip_StatusWidget.createCommentsTable = function (comments) {
        var html = '' +
            '<table id="commentsTable" class="tablesorter innerPanel w-full h-full" cellspacing="1">' +
                '<tbody>';

        if(comments && comments.length > 0){
            comments.reverse();

            cc_Util.invokeOnElements(comments, function () {
                var annotation = '' +
                    '<div class="tableCellAnnotation">' +
                        '<span>' + cip_StatusWidget.toExecutedActorName(this.actor) + '</span>' +
                        '<span>' + $.format.date(new Date(this.date), cc_Config.dateFormat) + '</span>' +
                    '</div>';
                html += '' +
                    '<tr id="comment_' + this.id + '" data-is-private="' + this.private + '">' +
                        '<td class="firstCell lastCell wrappingCell">' +
                            annotation +
                            '<div class="tableContentPanel">' + this.detail + '</div>' +
                        '</td>' +
                    '</tr>';
            });
        }else{
            html +=	'' +
                    '<tr>' +
                        '<td class="firstCell lastCell wrappingCell">' +
                            '<div class="tableContentPanel p-4 text-placeholder text-center">There are no comments</div>' +
                        '</td>' +
                    '</tr>';
        }
        html += '</tbody>' +
            '</table>';
        return html;
    }

    cip_StatusWidget.createDocumentsPanel = function (documents, supportsViewDocumentOperation, supportsRemoveDocumentOperation) {
        return '' +
            '<div id="documentsPanel">' +
                '<div class="panel-body sectionHeader">' +
                    '<legend>Documents</legend>' +
                    cip_StatusWidget.createDocumentsTable(documents, supportsViewDocumentOperation, supportsRemoveDocumentOperation) +
                '</div>' +
            '</div>';
    };

    cip_StatusWidget.createDocumentsTable = function (documents, supportsViewDocumentOperation, supportsRemoveDocumentOperation) {
        var documentsContents = function(documents) {
            function file(document) {
                var file = '';
                if(supportsViewDocumentOperation){
                    file = '' +
                            '<a class="documentView flex items-center space-x-2.5" document-id="' + document.id + '" href="' + cip_StatusWidget.toViewDocumentUrl(cc_Config.applicationId, document.id, document.documentName) + '" target="_blank">' +
                            '<i>' +
                                '<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"/>' +
                                '</svg>' +
                            '</i>' +
                            '<span class="font-bold">' +
                                document.documentName +
                            '</span>' +
                        '</a>';
                }else{
                    file = '<span class="documentRestrictedView">' + document.documentName + '</span>';
                }
                return file;
            }
            function descriptionAndTags(document) {
                return	'' +
                        '<div class=" flex flex-col space-y-2.5">' +
                            '<span>' + document.description + '</span>' +
                        '</div>' +
                    '';
            }
            function author(document) {
                return '<div class="">' + cip_StatusWidget.toExecutedActorName(document.actor) + '</div>';
            }
            function dateAndTime(document) {
                return '<div data-milliseconds="' + document.date + '"><div class="">' + $.format.date(new Date(document.date), cc_Config.dateFormat) + '</div></div>';
            }
            function visibilityAndActions(document) {

                var deleteButton = (supportsRemoveDocumentOperation === true && document.actor.type === "APPLICANT") ? '<div class="flex items-center gap-2.5"><i class="documentDelete text-error" document-id="'+ document.id + '">' +
                        '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.0535C14.4183 18.0535 18 14.4717 18 10.0535C18 5.63519 14.4183 2.05347 10 2.05347C5.58172 2.05347 2 5.63519 2 10.0535C2 14.4717 5.58172 18.0535 10 18.0535ZM10 20.0535C15.5228 20.0535 20 15.5763 20 10.0535C20 4.53062 15.5228 0.0534668 10 0.0534668C4.47715 0.0534668 0 4.53062 0 10.0535C0 15.5763 4.47715 20.0535 10 20.0535Z" fill="currentColor"/>' +
                            '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9674 5.87154C14.3579 6.26206 14.3579 6.89522 13.9674 7.28575L7.2326 14.0205C6.84207 14.411 6.20891 14.411 5.81838 14.0205C5.42786 13.63 5.42786 12.9968 5.81838 12.6063L12.5531 5.87154C12.9437 5.48101 13.5768 5.48101 13.9674 5.87154Z" fill="currentColor"/>' +
                            '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9673 14.0207C13.5768 14.4112 12.9436 14.4112 12.5531 14.0207L5.81835 7.28594C5.42783 6.89541 5.42783 6.26225 5.81835 5.87173C6.20888 5.4812 6.84204 5.4812 7.23257 5.87173L13.9673 12.6065C14.3579 12.997 14.3579 13.6302 13.9673 14.0207Z" fill="currentColor"/>' +
                        '</svg>' +
                    '</i></div>' : '';

                return '' +
                    '<div class=" flex justify-end items-center gap-4">' +
                        deleteButton +
                    '</div>';
            }

            documents.reverse();
            var html = '';
            cc_Util.invokeOnElements(documents, function () {
                html += '' +
                    '<tr id="document_' + this.id + '">' +
                        '<td class="firstCell lastCell wrappingCell">' +
                            '<div class="flex justify-between items-center">' +
                                '<div class="tableCellTitle">' +
                                    file(this) +
                                '</div>' +
                                '<div class="tableCellAnnotation">' +
                                    author(this) +
                                    dateAndTime(this) +
                                    visibilityAndActions(this) +
                                '</div>' +
                            '</div>' +
                            '<div class="tableContentPanel">' + descriptionAndTags(this) + '</div>' +
                        '</td>' +
                    '</tr>';
            });

            return html;
        };

        var emptyDocumentsPlaceholder = '' +
            '<tr>' +
                '<td class="firstCell lastCell wrappingCell" colspan="5"><div class="tableContentPanel p-4 text-placeholder text-center">There are no documents</div></td>' +
            '</tr>';

        var html = '' +
            '<table id="documentsTable" class="tablesorter innerPanel">' +
                '<tbody>' +
                    (documents && documents.length > 0 ? documentsContents(documents) : emptyDocumentsPlaceholder) +
                '</tbody>' +
            '</table>';

        return html;
    };

    cip_StatusWidget.toViewDocumentUrl = function (applicationId, documentId, documentName) {
        return cip_Common.toApplicationUrl() + '/' + applicationId + '/view/document/' + documentId + '/' + encodeURIComponent(documentName);
    };

    /********************************************************************************************************/
    /**** @CC This is the default direct to customer status page renderer                                ****/
    /********************************************************************************************************/

    cip_StatusUI.urlApplication;

    cip_StatusUI.attachApplicationSummaries = function (summaries) {
        if (summaries && summaries.length == 1) {
            cip_StatusUI.getApplicationDetail(summaries[0].id);

        } else {
            $('#summaryPanel').empty().append(cip_StatusWidget.createApplicationSummaryTable(summaries));

            if (summaries && summaries.length > 0) {
                $('#summaryPanel').find("table").tablesorter().bind('applyWidgets', function () {
                    cip_StatusUI.initApplicationSummaryTablePanel();
                });
            }

            cip_StatusUI.initApplicationSummaryTablePanel();

            // is a single summary from a viewInterview call OR
            // a array with one element for a getApplicationSummaries call
            if (summaries.id) {
                cip_StatusController.processSelectedApplicationDetailResponse(cip_StatusUI.urlApplication);
            }

            $('#summaryPanel').show();
        }
    };

    cip_StatusUI.initApplicationSummaryTablePanel = function () {
        $('#summaryTable tr td').hover(
            function () {
                $(this).parent().addClass('hover');
            },
            function () {
                $(this).parent().removeClass('hover');
            }
        ).click(function () {
            cip_StatusUI.getApplicationDetail($(this).parent().attr('data-id'));
        });
    };

    cip_StatusUI.getApplicationDetail = function (applicationId) {
        cip_StatusServer.getApplicationDetail(applicationId, function (response) {
            cip_StatusController.processSelectedApplicationDetailResponse(response);
        });
    };

    cip_StatusUI.setSelectedAppliationSummary = function (applicationId) {
        cc_Config.applicationId = applicationId;
        cip_StatusUI.selectedApplicationId = applicationId;
        $('#summaryTable tr').removeClass('selected').parent().find('#summary_' + applicationId).addClass('selected');
    };

    cip_StatusUI.attachApplicationDetail = function (application) {
        cip_StatusUI.setSelectedAppliationSummary(application.detail.id);

        cip_StatusUI.attachOverviewPanel(application.detail);
        cip_StatusUI.attachDocumentsPanel(application.detail);
        cip_StatusUI.attachCommentsPanel(application.detail);
    };

    cip_StatusUI.attachOverviewPanel = function (detail) {
        $('#applicationDetailOverviewPanel').empty().append(cip_StatusWidget.createOverviewPanel(detail));

        $('input.nextStepOperation').click(function () {
            var jButton = $(this);

            var ok = function () {
                cip_StatusServer.nextStep(detail.id, jButton.attr('custom-operation-id'), function () {
                    cip_StatusUI.setSelectedAppliationSummary(detail.id);

                    cip_StatusServer.getApplicationDetail(cip_StatusUI.selectedApplicationId, function (response) {
                        cip_StatusController.processSelectedApplicationDetailResponse(response);
                    });
                });
            };

            var confirmationText = jButton.attr('custom-operation-confirmation-text');

            if (confirmationText) {
                cc_UI.showConfirmDialog(confirmationText, function () {
                    ok();
                });
            } else {
                ok();
            }
        });

        if (cip_Entity.onStatusAttached) {
            cip_Entity.onStatusAttached(detail);
        }

        $('#applicationDetailOverviewPanel').show();
    };

    cip_StatusUI.attachCommentsPanel = function (detail) {
        var hasComments = detail.comments && detail.comments.length > 0;
        var supportsAddCommentOperation = detail.addCommentOperation != null;

        if (hasComments === true || supportsAddCommentOperation === true) {
            $('#applicationDetailCommentsPanel').empty().append(cip_StatusWidget.createCommentsPanel(detail.comments));

            $('#applicationDetailCommentsPanel table').tablesorter({
                headers: {
                    0: {sorter: false},
                    1: {sorter: false}
                }
            });

            if (supportsAddCommentOperation === true) {
                $('input[name=addCommentButton]').click(function () {
                    cc_UI.createSimpleDialog({
                        id: cip_StatusCommentDialog.id(),
                        title: cip_StatusCommentDialog.title(),
                        content: cip_StatusCommentDialog.content(),
                        width: cip_StatusCommentDialog.width(),
                        firstOpen: cip_StatusCommentDialog.firstOpen,
                        ok: function () {
                            var commentDetail = cip_StatusCommentDialog.unpopulate();

                            if (commentDetail && commentDetail.length > 0) {
                                cip_StatusServer.addComment(detail.id, commentDetail, function () {
                                    cip_StatusServer.getApplicationDetail(cip_StatusUI.selectedApplicationId, function (response) {
                                        cip_StatusController.processSelectedApplicationDetailResponse(response);

                                        cc_UI.moveToPageAnchor("applicationDetailCommentsPanel")
                                    });
                                });

                                $('#' + cip_StatusCommentDialog.id()).dialog("close");

                            } else {
                                cc_UI.showErrorDialog("Comment is required", "Invalid Comment");
                            }
                        }
                    });
                });
            }

            $('#applicationDetailCommentsPanel').show();

        } else {
            $('#applicationDetailCommentsPanel').hide();
        }
    };

    cip_StatusUI.attachDocumentsPanel = function (detail) {
        var hasDocuments = detail.documents && detail.documents.length > 0;
        var supportsAddDocumentOperation = detail.addDocumentOperation != null;
        var supportsViewDocumentOperation = detail.viewDocumentOperation != null;
        var supportsRemoveDocumentOperation = detail.removeDocumentOperation != null;

        if (supportsAddDocumentOperation === true || supportsViewDocumentOperation === true || supportsRemoveDocumentOperation === true) {
            $('#applicationDetailDocumentsPanel').empty().append(cip_StatusWidget.createDocumentsPanel(detail.documents, supportsViewDocumentOperation, supportsRemoveDocumentOperation));

            $('#applicationDetailDocumentsPanel table').tablesorter({
                headers: {
                    0: {sorter: false},
                    1: {sorter: false}
                }
            });

            if (supportsAddDocumentOperation === true) {
                $('input[name=addDocumentButton]').click(function () {
                    cc_UI.createSimpleDialog({
                        id: cip_StatusDocumentDialog.id(),
                        title: cip_StatusDocumentDialog.title(),
                        content: cip_StatusDocumentDialog.content(),
                        width: cip_StatusDocumentDialog.width(),
                        firstOpen: cip_StatusDocumentDialog.firstOpen,
                        ok: function () {
                            var documentDetail = cip_StatusDocumentDialog.unpopulate();

                            cip_StatusServer.addDocument(detail.id, $('#documentFileForm'), function () {
                                cip_StatusServer.getApplicationDetail(cip_StatusUI.selectedApplicationId, function (response) {
                                    cip_StatusController.processSelectedApplicationDetailResponse(response);

                                    cc_UI.moveToPageAnchor("applicationDetailDocumentsPanel")
                                });

                                $('#' + cip_StatusDocumentDialog.id()).dialog("close");
                            });
                        }
                    });
                });
            }

            if (supportsRemoveDocumentOperation === true) {
                $('#documentsTable .documentDelete').click(function () {
                    var selectedDocumentId = $(this).attr('document-id');

                    cc_UI.showConfirmDialog("Are you sure you want to delete document?", function () {
                        cip_StatusServer.deleteDocument(cip_StatusUI.selectedApplicationId, selectedDocumentId, function (response) {
                            cip_StatusServer.getApplicationDetail(cip_StatusUI.selectedApplicationId, function (response) {
                                cip_StatusController.processSelectedApplicationDetailResponse(response);
                            });
                        });
                    });
                });
            }

            $('#applicationDetailDocumentsPanel').show();

        } else {
            $('#applicationDetailDocumentsPanel').hide();
        }
    };
})();